export enum GraphType {
    COST = "cost",
    ENERGY = "energy"
}